import { signOut } from '@firebase/auth';
import React from 'react'
import { Link, useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { auth } from '../../config/firebase.config';

const Navbar = ({ toggleLoginModal, currentUser }) => {
  const navigate = useNavigate();

  const handleLogout = async () => {
    try {
        await signOut(auth);
        toast.success('Logout Successfully');
        navigate('/');
    } catch (error) {
      toast.error(error.message);
    }
  }

  return (
    <div className='bg-blue-500 text-white py-2'>
      <div className='container mx-auto flex justify-between items-start md:items-center w-[90%] flex-col md:flex-row'>
        <h1 className='text-2xl font-bold'>
          <Link to={currentUser ? '/dashboard' : '/'}> Documentor </Link>
        </h1>
        {
          currentUser ? (
            <div className='flex items-start md:items-center gap-2 flex-col md:flex-row w-full md:w-fit my-2 md:my-0'>
              <div className='flex items-center gap-2'>
                <h1>{currentUser?.displayName}</h1>
                <img src={currentUser?.photoURL} alt={currentUser?.displayName} className='rounded-full w-10' />
              </div>
              <button
                onClick={handleLogout}
                className='border-2 border-transparent bg-red-500 px-5 py-2 rounded-md my-3 w-full md:w-fit'>Logout</button>
            </div>
          ) : (
            <button
              onClick={toggleLoginModal}
              className='border-2 border-white px-5 py-2 rounded-md'>Login</button>
          )
        }
      </div>
    </div>
  )
}

export default Navbar